import { render, staticRenderFns } from "./Policy-medicine.vue?vue&type=template&id=7ea2bf3c&scoped=true"
import script from "./Policy-medicine.js?vue&type=script&lang=js&external"
export * from "./Policy-medicine.js?vue&type=script&lang=js&external"
import style0 from "./Policy-medicine.vue?vue&type=style&index=0&id=7ea2bf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2bf3c",
  null
  
)

export default component.exports